import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'includes'
})
export class IncludesPipe implements PipeTransform {
    transform(value: any[], args: any[]): boolean {
        return value.includes(args[0])
    }
}